import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "maintenance-schedule-trim" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("option", {
    disabled: "",
    value: "undefined"
}, "Select a Trim", -1 /* HOISTED */);
const _hoisted_4 = ["value", "aria-selected"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showTrimQuestion)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.questionTrimAnswer) = $event)),
                class: "maintenance-schedule-trim__dropdown form-control",
                required: "",
                "aria-label": "Select A Vehicle Trim",
                disabled: _ctx.fieldIsDisabled,
                onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.answered($event)))
            }, [
                _hoisted_3,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionTrimAnswers, (trim, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        class: "trim",
                        value: trim,
                        "aria-selected": trim == _ctx.questionTrimAnswer
                    }, _toDisplayString(trim), 9 /* TEXT, PROPS */, _hoisted_4));
                }), 128 /* KEYED_FRAGMENT */))
            ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2)), [
                [_vModelSelect, _ctx.questionTrimAnswer]
            ])
            : _createCommentVNode("v-if", true)
    ]));
}
